import { render } from "./TheApp.vue?vue&type=template&id=7bece7ac"
import script from "./TheApp.vue?vue&type=script&lang=js"
export * from "./TheApp.vue?vue&type=script&lang=js"

import "./TheApp.vue?vue&type=style&index=0&id=7bece7ac&lang=css"

import exportComponent from "/home/tachyon/websocket/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__